import createVueApp from '@/common/createApp'

Styxie.Initializers.Mlap = {
  show: async(props) => {
    if (props.splash) {
      const { default: MlapSplash } = await import('@/vue_widgets/mlap/splash/index.vue')
      createVueApp(MlapSplash, { props })
    } else {
      const { default: MlapProjectsIndex } = await import('@/vue_widgets/mlap/projects/index.vue')
      createVueApp(MlapProjectsIndex, { props })
    }
  }
}
